<template>
  <p ref="contentText" class="review-comment-text body" :class="{ expanded: isExpanded }" v-html="sanitize(content, whitelist)"></p>
  <button v-if="hasTruncation" class="view-btn small-margin-top-xxs large-margin-top-xs margin-bottom-xxs link-med" @click="expandToggle">
    {{ buttonText }}
  </button>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { sanitize } from '@vue-util/sanitize';
import { useProduct } from '~/modules/product/composables/useProduct';
import { trackEvent } from '~/utils/bvPixel';

defineProps({
  content: {
    type: String,
    required: true,
  },
});

const whitelist = {
  whiteList: {
    span: ['class'],
  },
};

const { productId } = useProduct();

const contentText = ref(null);
const isExpanded = ref(false);
const buttonText = computed(() => (isExpanded.value ? 'View less' : 'View more'));

const hasTruncation = ref(false);

function getHasTruncation() {
  if (contentText?.value) {
    return contentText?.value.scrollHeight > contentText?.value.clientHeight + 2;
  }
  return false;
}

watch(contentText, () =>
  setTimeout(() => {
    // TODO: investigate alternate solution to setTimeout
    hasTruncation.value = getHasTruncation();
  }, 0),
);

function expandToggle() {
  isExpanded.value = !isExpanded.value;
  trackEvent('view_more', productId, isExpanded.value ? 'expanded' : 'condensed');
}
</script>

<style scoped lang="scss">
.review-comment-text {
  word-wrap: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  &.expanded {
    -webkit-line-clamp: unset;
    overflow: visible;
  }
}
.view-btn {
  align-self: flex-start;
}
</style>
